module.exports = __webpack_public_path__ + "img/CD.e794ff52.png";